import { render } from "./CustomPageToolbar.vue?vue&type=template&id=6865e8d8"
import script from "./CustomPageToolbar.vue?vue&type=script&lang=js"
export * from "./CustomPageToolbar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__